import { Box } from "@mui/material";
import type { ReactNode } from "react";

export interface FilterBarProps {
  children: ReactNode;
}

export function FilterBar({ children }: FilterBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        flexWrap: "wrap",
        alignItems: { sm: "flex-end" },
        "& > *:not([data-filterbar-wide='true'])": {
          minWidth: { xs: "100%", sm: "180px" },
          maxWidth: { xs: "100%", sm: "240px" },
          flex: { sm: "0 1 auto" },
        },
      }}
    >
      {children}
    </Box>
  );
}
